/** Count bookable listings, including ongoing workshops with no scheduled date. */
const countAvailableWorkshops = (
    workshops,
    now = new Date(),
) => {
    if (!Array.isArray(workshops)) return 0;

    // Clinic dates are calendar dates in Los Angeles, regardless of the visitor's timezone.
    const today = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(now);

    return workshops.filter(({ event_date: eventDate }) => {
        if (!eventDate?.trim()) return true;
        const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(eventDate);
        if (!match) return false;
        const [, month, day, year] = match;
        const date = `${year}-${month}-${day}`;
        const parsed = new Date(`${date}T12:00:00Z`);
        return (
            !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date && date >= today
        );
    }).length;
};

export default countAvailableWorkshops;
